// extracted by mini-css-extract-plugin
export default {"StickyBlock":"bfk_a bik_bj"};